
import { defineComponent, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "KTBcn",
  props: {
    breadcrumbs: Array,
    title: String,
  },
  setup() {
    const store = useStore();
    const { t, te } = useI18n();

    const menuConfig = ref([]);
    const rootName = ref("Home");

    menuConfig.value = store.getters.menuConfig;

    watch(
      () => store.getters.menuConfig,
      (newVal) => {
        menuConfig.value = newVal;
        getBcnRoot(newVal);
      }
    );

    const getBcnRoot = (menu) => {
      if (menu && menu.length > 0) {
        menu.forEach((item) => {
          if (item.belong == process.env.VUE_APP_SAAS_SYSTEM) {
            rootName.value = item.heading;
          }
        });
      }
    };

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    onMounted(() => {
      getBcnRoot(menuConfig.value);
    });

    return {
      translate,
      rootName,
    };
  },
});
